<template>
  <div class="py-20">
    <div class="container mx-auto px-6">
      <div class="mx-auto max-w-7xl">
        <div v-reveal class="mb-16 text-center">
          <h2 class="mb-6 text-3xl font-bold text-ternary-dark dark:text-primary-light sm:text-4xl">
            {{ title }} <span class="bg-gradient-to-r from-accent to-gradient-end bg-clip-text text-transparent">{{ highlightedTitle }}</span>
          </h2>
          <p class="mx-auto max-w-3xl text-lg text-gray-600 dark:text-gray-400">
            {{ description }}
          </p>
        </div>

        <div class="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          <ServiceCard
            v-for="(service, index) in services"
            :key="service.id"
            v-reveal="(index % 3) * 90"
            :service="service"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Service } from '~/data/services'
import ServiceCard from '~/components/Services/ServiceCard.vue'

interface Props {
  title: string
  highlightedTitle: string
  description: string
  services: Service[]
}

defineProps<Props>()
</script>
